import React, { useContext, useEffect, useState } from "react";
import { getCurrentUser, logout } from "../util/auth";

export const AuthContext = React.createContext();

export const AuthContextProvider = ({ children }) => {
  const [userState, setUserState] = useState(() => getCurrentUser());

  const logoutUser = React.useCallback(() => {
    logout();       // clear session/token storage
    setUserState(null);  // reset user state
  }, []);

  const syncLogout = React.useCallback((e) => {
    if (e.key === "authUser" && e.oldValue && !e.newValue) {
      logout();
      setUserState(null);
    }
  }, []);
  // syncing auth state on different tabs
  useEffect(() => {
    window.addEventListener("storage", syncLogout);
    return () => window.removeEventListener("storage", syncLogout);
  }, [syncLogout]);

  const contextValue = React.useMemo(() => ({
    userState,
    setUserState,
    logoutUser,
  }), [userState, logoutUser]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthContextProvider");
  }
  return context;
};
